import { number, string } from 'yup'

export const activityComplementaryInfoSchema = {
  description: string(),
  sellingDeadline: number().min(0, 'Os minutos devem ser positivos')
}
